import get from 'lodash/get';

const getTypeDependsOnWidgetType = (attrs: string[], getClass: (value) => any) => {
  return (typeHelper: any) => {
    const attrValues = attrs.map(attr => get(typeHelper.object, attr));
    return getClass(attrValues);
  };
};

export default getTypeDependsOnWidgetType;
